module.exports = __webpack_public_path__ + "img/speech recognition.ea740468.png";